export default function Price({ value }){
  return new Intl.NumberFormat("es-ar", 
    { 
      style: "currency", 
      currency: "ARS" 
    }).format(value);
}